import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiCalendar, FiStar } = FiIcons;

const HeroSection = ({ currentArea }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
     {
      title: `Domestic Cleaning ${currentArea}`,
      image: '/img/domestic-homepage.webp'
    },
    {
      title: `Commercial Cleaning ${currentArea}`,
      image: '/img/store.webp'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen sm:min-h-[120vh] md:min-h-[110vh] lg:min-h-screen overflow-hidden pt-20 sm:pt-24 md:pt-32 lg:pt-20">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="w-full h-full bg-cover bg-center"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${slide.image})`
            }}
          />
        </div>
      ))}

      <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="max-w-7xl mx-auto w-full">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
            {/* Hero Text */}
            <div className="text-center lg:text-left lg:w-1/2 px-4 lg:px-8">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight">
                {slides[currentSlide].title}
              </h1>
            </div>

            {/* CTA Card */}
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-md w-full lg:w-auto lg:max-w-lg">
              <div className="text-center mb-6">
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                  Ready to have your property cleaned from top to bottom?
                </h2>
                <p className="text-gray-600 mb-6 text-base sm:text-lg">
                  Welcome to Diamond Cleaning. We're a very reliable commercial and domestic cleaning company in {currentArea}. Get in touch with our local office today.
                </p>

                <div className="flex justify-center mb-3">
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <SafeIcon
                        key={i}
                        icon={FiStar}
                        className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-400 fill-current"
                      />
                    ))}
                  </div>
                </div>
                <div className="text-sm sm:text-base font-semibold text-gray-700 mb-6 sm:mb-8">
                  91% of clients recommend our service
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <Link
                  to="/book"
                  className="w-full bg-blue-600 text-white py-3 sm:py-4 px-4 sm:px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-center flex items-center justify-center space-x-2 text-base sm:text-lg"
                  onClick={handleLinkClick}
                >
                  <SafeIcon icon={FiCalendar} className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span>Book Online Now</span>
                </Link>
                
                <a
                  href="tel:07878522378"
                  className="w-full bg-green-600 text-white py-3 sm:py-4 px-4 sm:px-6 rounded-lg hover:bg-green-700 transition-colors font-semibold text-center flex items-center justify-center space-x-2 text-base sm:text-lg"
                >
                  <SafeIcon icon={FiPhone} className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span>Call: 07878 522378</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 sm:w-4 sm:h-4 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-white scale-110'
                : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;